module.exports = __webpack_public_path__ + "files/578f8be09c746aef2febb78fa5c963f4.svg";